






















import { Vue, Component, Prop } from "vue-property-decorator";
import { TemplateSection } from "@/store/template/types";
import FormSection from "./FormSection.vue";

@Component({
  components: {
    FormSection
  }
})
export default class DynamicForm extends Vue {
  store = this.$store.direct;

  @Prop() form!: TemplateSection[];

  valid = true;
}
